var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHipaaModeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 1.626A1.632 1.632 0 0018.37.004H1.632A1.633 1.633 0 00.01 1.636L0 7.754a12.62 12.62 0 009.884 12.223.81.81 0 00.333 0A12.62 12.62 0 0019.99 7.666l.01-6.04zm-4.583 8.75a.542.542 0 01-.542.542h-2.292a.417.417 0 00-.416.417v2.291a.542.542 0 01-.542.542h-3.25a.542.542 0 01-.542-.542v-2.291a.417.417 0 00-.416-.417H5.125a.54.54 0 01-.542-.542v-3.25a.542.542 0 01.542-.541h2.292a.417.417 0 00.416-.417v-2.29a.542.542 0 01.542-.54h3.25a.542.542 0 01.542.54v2.293a.417.417 0 00.416.416h2.292a.542.542 0 01.542.542v3.247z"
  })));
}

export default SvgHipaaModeIcon;